// src/modules/app-views/goodsReceipt/components/CardHeaderGoodsReceiptTitle.jsx
// *******************************************************************************
// CARD HEADER TITLE: Supplier (Issuer) Name
// *******************************************************************************
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import useZustand from 'hooks/useZustand';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderGoodsReceiptTitle = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const currentPage = useZustand?.('module', 'currentPage', false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const data = currentPage?.data;
  const isNew = !data?._id || data?._id === 'add';

  const issuerName =
    data?.issuer?.tradeName ||
    data?.issuer?.name ||
    data?.issuerEntity?.fullName ||
    data?.issuerEntity?.name;

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (isNew && !issuerName) {
    return <span className="text-muted opacity-0-7">{translateX('supplier')}</span>;
  }

  return <span>{issuerName || translateX('supplier')}</span>;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderGoodsReceiptTitle;
